// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2pGfq","label":"CategoryService_label__3P4dH","location":"CategoryService_location__2J9SB"};